import React from "react";
import DistributorBalanceReport from "./DistributorBalanceReport";

const DistributorReceivableReport = () => <DistributorBalanceReport mode="receivable" />;

export default DistributorReceivableReport;
